import * as Sentry from '@sentry/nextjs';

import { APIRequestLabel } from '../consts';
import { callHttpGet } from '../http';

const getSupplies = (get, set) => {
  return async (blockType: string): Promise<void> => {
    // specs are static so make it lazy
    // for now we're using such a simple caching strategy, since we know that the
    // equipment list is static
    const eqs = get().supplies[blockType];
    if (eqs) {
      return eqs;
    }

    const params = { blockType: blockType };
    let q = new URLSearchParams(params).toString();
    await callHttpGet(get, set, APIRequestLabel.GET_SUPPLIES, `/supplies?${q}`);
    let apiCallStatus = get().apiCallStatus[APIRequestLabel.GET_SUPPLIES];
    if (apiCallStatus.error) {
      Sentry.captureMessage(JSON.stringify(apiCallStatus.error));
      return;
    }

    set({
      supplies: {
        ...get().supplies,
        [blockType]: apiCallStatus.response.supplies
      }
    });
  };
};

export { getSupplies };
